<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'SYSTEM-NOTES'" [breadcrumb]="''" [count]="count"
    icon="fa-comment-alt-lines">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="systemNoteGridAdvancedSwitch" [storageKey]="'system-notes-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search"
                    placeholder="{{ 'SEARCH-SYSTEM-NOTE' | translate }}" title="{{ 'SEARCH-SYSTEM-NOTE' | translate }}"
                    (keyup)="searchFieldChange(search.value)" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView" [loading]="loading" [navigable]="true"
            [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="enableAdvanced"
            [filter]="state.filter" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-SYSTEM-NOTES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="text" [width]="30" title="{{ 'SYSTEM-NOTE-TEXT' | translate }}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span
                        title="{{dataItem.text && dataItem.text.length > maxTextLength ? dataItem.text : ''}}">{{dataItem.text
                        | truncate: maxTextLength}}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdBy" [width]="16" title="{{ 'CREATED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="createdOn" [width]="16" title="{{ 'CREATED-DATE' | translate }}" filter="date"
                format="{0:g}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="16" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedOn" [width]="16" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem)">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-system-note-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-system-note-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <div style="max-height: 300px;">
        <span class="k-font-weight-bold">{{selectedSystemNote.text}}</span>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>